import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { authApi } from '@/api/auth'
import { useAuthStore } from '@/store/authStore'
import type { LoginCredentials } from '@/types/auth'

export function useAuth() {
  const { user, isAuthenticated, setAuth, logout: storeLogout } = useAuthStore()
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const login = async (credentials: LoginCredentials): Promise<void> => {
    setIsLoading(true)
    try {
      const { token, user } = await authApi.login(credentials)
      setAuth(token, user)
      navigate('/dashboard', { replace: true })
    } finally {
      setIsLoading(false)
    }
  }

  const logout = async (): Promise<void> => {
    setIsLoading(true)
    try {
      await authApi.logout()
    } finally {
      storeLogout()
      setIsLoading(false)
      navigate('/login', { replace: true })
    }
  }

  return { user, isAuthenticated, isLoading, login, logout }
}
